/* eslint-disable react/prop-types */

import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import Loading from "components/Loading";
import ModalUI from "components/ModalUI";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { updateGhollak } from "services/ghollak.routes";
import queryString from "utils/queryString";

export default function UpdateGhollakModal({ modalInfo,setGhollaks, closeModal }) {
    const [information, setInformation] = useState({});
    const [loading, setLoading] = useState(false);
    const handleChange = (event) => {
        const { name, value } = event.target;
        setInformation({ ...information, [name]: value });
    };
    useEffect(() => {
        if (modalInfo?.item)
            setInformation({ name: modalInfo?.item?.name, locked: modalInfo?.item?.locked })

    }, [])
    const handleCheckboxChange = (event) => {
        setInformation({ ...information, locked: event.target.checked });
    };
    const updateGhollakItem = async () => {
        if (modalInfo?.item) {
            setLoading(true);
            const query = { ...information, locked: +information.locked };
            updateGhollak(modalInfo?.item?.id, queryString(query), (isOk, data) => {
                setLoading(false);
                if (!isOk) {
                    return toast.error(data.message);
                } else {
                    toast.success("قلک ویرایش شد!");
                    setGhollaks(prevGhollaks => prevGhollaks.map(ghollak => 
                        ghollak.id === modalInfo.item.id ? { ...ghollak, ...information } : ghollak
                    ));
                    closeModal();
                }
            });
        }
    };
    return (
        <ModalUI open={modalInfo.state} handleClose={closeModal} style={{ minWidth: "600px" }}>
            <SoftBox py={3}>
                <Loading loading={loading} />
                <SoftBox component="form" role="form">
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} xl={12}>
                            <SoftBox mb={1} ml={0.5}>
                                <SoftTypography component="label" variant="caption" fontWeight="bold">
                                    نام
                                </SoftTypography>
                            </SoftBox>
                            <SoftInput name="name" value={information.name} onChange={handleChange}
                                type="text" placeholder="نام" />
                        </Grid>
                        {information.locked !== undefined && <Grid item xs={12} sm={12} xl={12}>
                            <FormControlLabel control={<Checkbox checked={information.locked} onChange={handleCheckboxChange}
                            />} label="قفل شود؟" />
                        </Grid>}
                    </Grid>
                </SoftBox>
                <SoftButton style={{ marginTop: 20 }} onClick={updateGhollakItem} variant="gradient" color="info">
                    ویرایش
                </SoftButton>

            </SoftBox>
        </ModalUI>
    )
}